import { formatNumber } from './number';

export type FormatQuantityOptions = {
  locale?: string;
  /** Unit label appended with space when present (e.g. EA, KG). */
  unit?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  /** Drop trailing .00 for cleaner qty labels (quotation style). */
  trimTrailingZeros?: boolean;
  nullDisplay?: string;
};

/**
 * Manufacturing / EPC quantities — independent from money precision.
 * Default: up to 3 fraction digits, min 0.
 */
export function formatQuantity(value: unknown, options: FormatQuantityOptions = {}): string {
  const min = options.minimumFractionDigits ?? 0;
  const max = options.maximumFractionDigits ?? 3;
  let s = formatNumber(value, {
    locale: options.locale,
    minimumFractionDigits: min,
    maximumFractionDigits: max,
    nullDisplay: options.nullDisplay,
  });
  if (!s) return s;
  if (options.trimTrailingZeros) {
    s = s.replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
  }
  if (options.unit) return `${s} ${options.unit}`;
  return s;
}
